import { CounterPrice, type MultiVoucherItemType } from 'app/src/features/ProductDetail/components/CounterPrice'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { euroFormatterIt } from 'app/src/shared/helpers'
import { type ReactElement } from 'react'

export function ProductMultiPurchase(props: {
  variants: companyagreementApi.Variant[]
  multiPurchaseTotal: number
  setMultiPurchaseTotal: React.Dispatch<React.SetStateAction<number>>
  selectedPriceVoucher: MultiVoucherItemType<companyagreementApi.Variant | undefined>[]
  setSelectedPriceVoucher: React.Dispatch<React.SetStateAction<MultiVoucherItemType<companyagreementApi.Variant | undefined>[]>>
  multiPurchaseDescription: string
  multiPurchaseTotalDescription: string
}): ReactElement {
  const counterPriceSorting = (vara: companyagreementApi.Variant, varb: companyagreementApi.Variant): number => {
    if (vara?.priceDetails?.facePrice && varb?.priceDetails?.facePrice)
      return vara?.priceDetails?.facePrice < varb?.priceDetails?.facePrice ? 1 : -1
    else if (vara?.priceDetails?.facePrice) return 1
    else return -1
  }
  function onChangeQuantity(item: MultiVoucherItemType<companyagreementApi.Variant>) {
    const isThere = props.selectedPriceVoucher?.find((x) => x.id === item.id)

    const newSelection =
      isThere && item.quantity === 0
        ? props.selectedPriceVoucher.filter((x) => x.id !== item.id)
        : isThere && item.quantity > 0
          ? props.selectedPriceVoucher.map((x) => (x.id === item.id ? item : x))
          : !isThere && item.quantity > 0
            ? [...props.selectedPriceVoucher, item]
            : props.selectedPriceVoucher

    props.setSelectedPriceVoucher(newSelection)

    if (newSelection.length > 0) {
      let tot: number = 0
      newSelection.forEach((priceItem) => {
        tot = tot + priceItem.quantity * priceItem.unitPrice!
      })
      props.setMultiPurchaseTotal(tot)
    } else props.setMultiPurchaseTotal(0)
  }

  return (
    <div className='col-span-12 my-[20px] flex flex-col items-center p-[20px]'>
      <p className='my-[20px]'>{props.multiPurchaseDescription}</p>
      {props.variants.sort(counterPriceSorting).map((variant, i) => (
        <CounterPrice
          key={variant.variantId}
          item={{
            id: variant.variantId,
            active: variant.active,
            label: variant.variantName,
            quantity: 0,
            unitPrice: variant.priceDetails?.facePrice,
            payload: variant,
          }}
          isLast={i === props.variants.length - 1}
          callbackOnChangeQuantity={onChangeQuantity}
        />
      ))}
      <div
        className='col-span-12 flex max-w-[500px] flex-row items-center justify-between p-[20px]'
        style={{ width: '-webkit-fill-available' }}
      >
        <div className='flex min-w-[33%] flex-1 justify-start text-[18px] font-bold'>{props.multiPurchaseTotalDescription}</div>
        <div className='flex min-w-[33%] flex-1 justify-end text-[18px] font-bold'>
          {euroFormatterIt.format(props.multiPurchaseTotal)}
        </div>
      </div>
    </div>
  )
}
